import * as yup from 'yup';

import 'yup-phone';

const phoneSchema = yup.string().phone();

export default {
  phoneSchema,
};
